import type { PinnedMessage } from '@swchat/client-sdk';
import { useState } from 'react';
import { Icon } from '../design';
import { quoteText } from '../lib/display';

/** Số tin ghim hiện sẵn; nhiều hơn thì có "Xem tất cả". */
const SHOWN = 3;

/**
 * W2.1: dải "Tin nhắn đã ghim" dưới đầu hội thoại — bấm một tin để cuộn tới và tô sáng (tin trong luồng → mở luồng).
 * Danh sách ghim là trạng thái cục bộ suy từ payload `pin` (MLS); server không biết tin nào được ghim.
 */
export function PinnedBar({
  pinned,
  senderName,
  onOpen,
}: {
  pinned: PinnedMessage[];
  senderName: (userId: string) => string | undefined;
  onOpen: (p: PinnedMessage) => void;
}) {
  const [all, setAll] = useState(false);
  if (!pinned.length) return null;
  const shown = all ? pinned : pinned.slice(0, SHOWN);
  return (
    <div className="ws-pinned-bar" data-testid="pinned-bar" role="region" aria-label="Tin nhắn đã ghim">
      <div className="ws-pinned-head">
        <Icon name="pin" size={14} />
        <strong>Tin nhắn đã ghim</strong>
        <span className="ws-muted">({pinned.length})</span>
        {pinned.length > SHOWN && (
          <button type="button" className="ws-link-btn" data-testid="pinned-toggle" onClick={() => setAll((a) => !a)}>
            {all ? 'Thu gọn' : 'Xem tất cả'}
          </button>
        )}
      </div>
      <ul className="ws-pinned-list">
        {shown.map((p) => {
          const q = quoteText(p.message, senderName);
          return (
            <li key={p.id}>
              <button type="button" className="ws-pinned-item" data-testid="pinned-item" data-msg-id={p.id} onClick={() => onOpen(p)}>
                <strong>{q.sender}:</strong>
                <span>{q.text}</span>
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
